import React from 'react';
import { IConfigData, OperationBtn } from '../type';
import { Bubble, Button } from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { history } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import ACard from '../../ACard';

// 基础props
export interface OperationListProps {
  // 组件配置
  operationList?: OperationBtn[];
  data: IConfigData;
}

interface ParamsObject {
  [key: string]: string;
}

// 操作按钮组
const OperationList = (props: OperationListProps) => {
  const { data = {}, operationList = [] } = props;
  const { isEN } = useLocal();

  const getUrl = (item: OperationBtn) => {
    const { params, url } = item;
    let jumpUrl = url;
    if (typeof url === 'function') {
      jumpUrl = url(data);
    } else if (typeof url === 'string' && params) {
      const paramsObj = mapObjProperties(data, params);
      const paramsStr = Object.keys(paramsObj)
        .map(
          (k) => `${encodeURIComponent(k)}=${encodeURIComponent(paramsObj[k])}`,
        )
        .join('&');
      jumpUrl = `${url}?${paramsStr}`;
    }
    return jumpUrl as string;
  };

  // 点击跳转
  const onClick = (item: OperationBtn) => {
    const { isInlineOpen = true, isOutsideStation = false } = item;
    const jumpUrl = getUrl(item);

    // 站内url跳转强制使用umi的跳转
    if (!isOutsideStation) {
      history.push(jumpUrl as string);
      return;
    }

    if (isInlineOpen) {
      location.href = jumpUrl as string;
    } else {
      window.open(jumpUrl as string);
    }
  };

  // 获取data中对应的params配置属性值, 并转换成url参数字符串
  const mapObjProperties = (orgObject: any, mapObj: ParamsObject) => {
    const resObj: ParamsObject = {};

    Object.keys(mapObj).forEach((key) => {
      const valueStr = mapObj[key];
      const value = valueStr
        ?.split('.')
        ?.reduce((o, p) => o?.[p], orgObject);
      resObj[key] = value;
    });

    return resObj;
  };

  return operationList?.map((item: OperationBtn) => {
    const {
      tipCn,
      tipEn,
      permission,
      nameCn,
      nameEn,
      isDisabled,
      disabledType = 'disbaled',
      btnOptions = {},
      svgIconOptions,
      show,
    } = item;
    const tipCopntent = isEN ? tipEn : tipCn;
    const name = isEN ? nameCn : nameEn;
    // 兼容之前不传show默认true的逻辑
    let isShow: boolean = show === undefined ? true : show;
    let isDis = isDisabled;
    if (permission) {
      // isDisabled优先级最高
      isDis =
        isDisabled ||
        !permission.split('.')?.reduce((o, p) => o?.[p], data);
    }

    if (disabledType === 'hidden') {
      isShow = !isDis;
    }

    return (
      isShow && (
        <Bubble dark placement="left" content={tipCopntent}>
          <ACard url={getUrl(item)}>
            <Button
              className={`ns-btn--border btn-top`}
              {...btnOptions}
              onClick={() => onClick(item)}
              disabled={isDis}
            >
              {name}
              {svgIconOptions ? (
                <SvgIcon {...svgIconOptions} />
              ) : (
                <SvgIcon
                  style={{ width: '14px', height: '14px', marginLeft: '4px' }}
                  type="arrow-right"
                />
              )}
            </Button>
          </ACard>
        </Bubble>
      )
    );
  });
};

export default OperationList;
